import React, { Component } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGithub,
  faLinkedin,
  faStackOverflow
} from '@fortawesome/free-brands-svg-icons';

import {
  faTerminal,
  faCode
} from '@fortawesome/free-solid-svg-icons';

export default class Footer extends Component {
  render() {
    return (
      <React.Fragment>
    {/* footer
    ================================================== */}
      <footer>
        <div className="row">
          <div className="twelve columns">
            <ul className="social-links">
              <li><a href="https://www.linkedin.com/in/wilson-ler-664b51110"><FontAwesomeIcon icon={faLinkedin} /></a></li>
              <li><a href="https://open.kattis.com/users/wilson-ler"><FontAwesomeIcon icon={faTerminal} /></a></li>
              <li><a href="https://github.com/lws803"><FontAwesomeIcon icon={faGithub} /></a></li>
              <li><a href="https://stackoverflow.com/users/7041177/lws803"><FontAwesomeIcon icon={faStackOverflow} /></a></li>
              <li><a href="https://sourcerer.io/lws803"><FontAwesomeIcon icon={faCode} /></a></li>
            </ul>
            <ul className="copyright">
              <li>Design by <a title="Styleshout" href="http://www.styleshout.com/">Styleshout</a></li>   
            </ul>
          </div>
          <div id="go-top"><a className="smoothscroll" title="Back to Top" href="#home"><i className="icon-up-open" /></a></div>
        </div>
      </footer> {/* Footer End*/}

      </React.Fragment>
    );
  }
}
